import React, { PureComponent } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Cookies from 'universal-cookie';
import axios from 'axios';
import ReconnectingWebSocket from 'reconnecting-websocket';
import Button from '@material-ui/core/Button/Button';

import Header from '../../components/header/Header';
import RoleStatus from '../../components/role-status/RoleStatus';
import WorldDetail from '../../components/world-detail/WorldDetail';

import './WorldControlPanel.scss';
import CountdownTimer from '../../components/countdown-timer/CountdownTimer';
//import ChangesButton from "../../components/changes-button/ChangesButton";
import { CAMS_URL, FETCH_URL } from '../../constants/ServerLinks';
import { withRouter } from 'react-router-dom';
import { INSTRUCTOR_POLL_TIME } from '../../constants/Polling';

class WorldControlPanel extends PureComponent {
  constructor(props) {
    super(props);

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.cookies = new Cookies();
    this.token = this.cookies.get('token');
    this.origin = this.cookies.get('origin');
    this.worldEventSource = null;
    this.ws_scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    this.socket = null;

    this.state = {
      world: {},
      creation_info: '',
      configurations: {},
      scenarioSelected: '',
      snackMsg: 'Welcome!',
      snackOpen: false,
      snackType: 'snack-success',
      snackAutoHideDuration: null,
      startRequestSent: false,
      advanceRequestSent: false,
      resetRequestSent: false,
      participants: [],
      roleLogout: 'null',
      requestLogoutSent: false,
      navLinks: [
        {
          name: 'Instructor',
          href: '',
          icon: '--',
          target: '_',
        },
        {
          name: 'Logout',
          href: '/logout',
          icon: 'iconLogout',
          target: '',
        },
        // {
        //     name: 'Home',
        //     href: '/instructor',
        //     icon: 'iconHome',
        //     target: '_self',
        // },
        {
          name: 'Documentation',
          href: '/info',
          icon: 'iconInfo',
          target: '_self',
        },
        // {
        //   name: "Frank Batten School",
        //   href: "https://batten.virginia.edu",
        //   icon: "iconBatten",
        //   target: "_blank",
        // },
        // {
        //   name: "CLSG",
        //   href: "https://www.clsgbatten.org",
        //   icon: "iconClsg",
        //   target: "_blank",
        // },
      ],
      objectives: {},
      metrics: {},
    };
  }

  fetchUserNameAndPhoto = () => {
    axios
      .all([
        axios.get(this.camsURL + '/api/auth/user', {
          headers: { Authorization: `Token ${this.token}` },
        }),
        // axios.get(this.camsURL + "/api/v1/users/photo/", {
        //   headers: { Authorization: `Token ${this.token}` },
        // }),
      ])
      .then(
        axios.spread((detailsResponse, photoResponse) => {
          // console.group("WorldControlPanel:fetchUserNameAndPhoto");
          // console.log(detailsResponse);
          // console.log(photoResponse);
          // console.groupEnd();
          if (detailsResponse.status === 200) {
            let rolesInfo = detailsResponse.data;
            // let photoInfo = photoResponse.data;

            this.setState(() => {
              return {
                navLinks: this.state.navLinks.map((item) => {
                  if (item.name === 'Instructor') {
                    item.name =
                      rolesInfo.first_name + ' ' + rolesInfo.last_name;
                    item.bg = '';
                    return item;
                  } else {
                    return item;
                  }
                }),
              };
            });
          }
        })
      )
      .catch((error) => {
        console.log(error.message);
      });
  };

  authUser = () => {
    axios
      .get(this.camsURL + '/api/auth/user', {
        headers: { Authorization: `Token ${this.token}` },
      })
      .then((response) => {
        // console.group("WorldControlPanel:authUser");
        // console.log(response.data);
        // console.groupEnd();
        if (response.data) {
          this.fetchUserNameAndPhoto();
          this.fetchWorldData();
        } else {
          window.location.replace('/');
        }
      })
      .catch((error) => {
        console.log(error.response);
        window.location.replace('/');
      });
  };

  authUserWithSkey = () => {
    const world_skey = window.location.pathname.split('/')[3];
    this.cookies.set('world_skey', world_skey, { maxAge: 86400 });
    // console.log("Inside skey auth: skey, " + world_skey);
    axios
      .post(this.camsURL + '/api/v1/users/authenticate_by_skey/', {
        skey: world_skey,
      })
      .then((response) => {
        // console.log(response.data);
        // console.groupEnd();
        if (response.data) {
          // console.log("User Authenticated");
          this.cookies.set('token', response.data.token, { maxAge: 86400 });
          this.token = response.data.token;
          this.authUser();
        } else {
          window.location.replace('/');
        }
      })
      .catch((error) => {
        // console.log("Error detected");
        console.log(error.response);
        window.location.replace('/');
      });
  };

  fetchWorldData = () => {
    const world_skey = window.location.pathname.split('/')[3];
    axios
      .all([
        axios.get(this.fetchURL + '/api/v1/worlds/', {
          params: { world_skey: world_skey },
          headers: { Authorization: `Token ${this.token}` },
        }),
        axios.get(this.fetchURL + '/api/v1/worlds/configurations/', {
          headers: { Authorization: `Token ${this.token}` },
        }),
      ])
      .then(
        axios.spread((worldResponse, configResponse) => {
          // console.group("WorldControlPanel:fetchWorldData");
          // console.log(worldResponse);
          // console.log(configResponse);
          // console.groupEnd();
          if (worldResponse.data.success) {
            let info = worldResponse.data.data;
            this.setState({
              world: info.world,
              creation_info: info.creation_info,
              scenarioSelected: info.world.config_number,
            });
            this.fetchParticipants();
            this.fetchWorldMetrics()
              .then(() => this.fetchObjectives())
              .catch((error) => console.log(error.response));
          }
          this.eventListeners();
          if (configResponse.data.success) {
            let configs = configResponse.data.data;
            this.setState({ configurations: configs });
          }
        })
      )
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchWorldMetrics = () => {
    return axios
      .get(this.fetchURL + '/api/v1/metrics/', {
        params: { world_id: this.state.world.id },
      })
      .then((response) => {
        // console.group("WorldControlPanel:fetchWorldMetrics");
        // console.log(response.data.data);
        // console.groupEnd();
        const metrics = response.data.data;
        this.setState({ metrics: metrics });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchParticipants = () => {
    axios
      .get(this.fetchURL + '/api/v1/roles/status/', {
        params: { world_id: this.state.world.id },
        headers: { Authorization: `Token ${this.token}` },
      })
      .then((response) => {
        // console.group("WorldControlPanel:fetchParticipants");
        // console.log(response.data);
        // console.groupEnd();
        const participants = response.data.data;
        this.setState({ participants: participants });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  updateStatus = (e, worldId) => {
    e.preventDefault();

    axios
      .put(
        this.fetchURL + '/api/v1/worlds/',
        {
          world_id: worldId,
          is_active: !this.state.world.is_active,
        },
        { headers: { Authorization: `Token ${this.token}` } }
      )
      .then((response) => {
        if (response.data.success) {
          // console.group("WorldControlPanel:updateStatus");
          // console.log("Game status Updated!");
          // console.groupEnd();

          this.setState((prevState) => ({
            world: Object.assign({}, prevState.world, {
              is_active: !prevState.world.is_active,
            }),
            snackOpen: true,
            snackMsg: 'Game status Updated.',
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          }));
        } else {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
          snackAutoHideDuration: 5000,
        });
      });
  };

  eventListeners = () => {
    const world_skey = window.location.pathname.split('/')[3];
    let world_path = '';
    if (window.location.hostname === 'localhost') {
      world_path =
        this.ws_scheme + '://localhost:7000/worldsocket/' + world_skey;
    } else {
      world_path =
        this.ws_scheme + '://refugee.dmsi-sims.com/worldsocket/' + world_skey;
    }
    this.socket = new ReconnectingWebSocket(world_path);
    this.socket.addEventListener('open', (e) => {
      // console.log("ws opened", e)
    });
    this.socket.addEventListener('close', (e) => {
      // console.log("ws closed", e)
    });
    this.socket.addEventListener('message', (e) => {
      // console.log("ws message received", e)
      // console.log("Message within the data", JSON.parse(e.data))
      const data = JSON.parse(e.data).message;
      // console.log(data)
      if (data.message === 'participant joined') {
        this.setState({
          snackOpen: true,
          snackMsg: `The ${data.role_data.role_name} of ${
            data.country_data.country_name
          } has joined`,
          snackType: 'snack-success',
          snackAutoHideDuration: 5000,
        });
        this.pollingFunctions();
      }
      if (data.message === 'participant left world') {
        this.setState({
          snackOpen: true,
          snackMsg: `The ${data.role_name} of ${
            data.country_name
          } has left the world`,
          snackType: 'snack-success',
          snackAutoHideDuration: 5000,
        });
        this.pollingFunctions();
      }
    });
    this.socket.addEventListener('error', (e) => {
      console.log('ws error', e);
    });
  };

  componentDidMount = () => {
    const origin = window.location.href.split('/')[6];
    // console.log("origin: ", this.cookies.get('origin'), origin)
    if (origin && !this.cookies.get('origin')) {
      this.cookies.set('origin', origin, { maxAge: 86400 });
      this.origin = origin;
    } else {
      if (!this.cookies.get('origin')) {
        this.cookies.set('origin', 'NOT_CLSG', { maxAge: 86400, path: '/' });
        this.origin = 'NOT_CLSG';
      }
    }
    // if (origin !== "CLSG") {
    this.authUser();
    // } else {
    // console.log("User is from CLSG attempting to get token from backend...");
    //   this.authUserWithSkey();
    // }
  };

  componentWillUnmount = () => {
    this.socket.close();
  };

  pollingFunctions = () => {
    this.fetchParticipants();
  };

  onNavLinkClick = (e, nav) => {
    e.preventDefault();

    if (nav.target === '_self') {
      this.props.history.push(nav.href);
    } else if (nav.target === '_blank') {
      window.open(nav.href, '_blank');
    } else {
      this.setState({
        snackType: 'snack-logout',
        snackOpen: true,
        snackMsg: 'Are you sure you want to logout?',
      });
    }
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  logoutYes = () => {
    this.setState({ requestSent: true });
    axios
      .post(
        this.camsURL + '/api/auth/logout',
        {},
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        this.setState({ requestSent: false });

        if (response.status === 204 || response.status === 200) {
          this.setState({
            snackOpen: true,
            snackMsg: `Logout successful!`,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });
          this.cookies.remove('token');
          this.cookies.remove('uid');
          this.cookies.remove('origin');
          window.location.replace('/');
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ requestSent: false });
      });
  };

  startScenario = (e) => {
    e.preventDefault();
    this.setState({
      snackType: 'snack-start',
      snackOpen: true,
      snackMsg:
        'Are all roles logged in? Do you want to start scenario ' +
        this.state.scenarioSelected.toString() +
        '?',
    });
  };

  startScenarioYes = () => {
    this.setState({ startRequestSent: true });
    this.handleClose();
    // console.group("WorldControlPanel:startScenarioYes");
    // console.log("Starting scenario confirmed!");
    // console.log(
    //   `world_id: ${this.state.world.id}, config_number: ${
    //     this.state.scenarioSelected
    //   }`
    // );
    axios
      .post(
        this.fetchURL + '/api/v1/worlds/games/',
        {
          world_id: this.state.world.id,
          config_number: this.state.scenarioSelected,
          skey: this.state.world.skey,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        // console.log(`Here is the response:  ${response}`);
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          // console.group("WorldControlPanel:startScenario");
          // console.log("World Initialized!");
          // console.log(response.data.data);
          // console.groupEnd();
          let info = response.data.data;

          this.setState({
            world: info,
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });

          // added to update objectives after starting the scenario
          // window.location.reload();
          this.fetchWorldMetrics()
            .then(() => this.fetchObjectives())
            .catch((error) => console.log(error.response));
        } else {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: null,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
          snackAutoHideDuration: 5000,
        });
      });
    // console.groupEnd();
  };

  advanceScenario = (e) => {
    e.preventDefault();
    this.setState({
      snackType: 'snack-advance',
      snackOpen: true,
      snackMsg:
        'Do you want to advance scenario ' +
        this.state.scenarioSelected.toString() +
        '?',
    });
  };

  advanceScenarioYes = () => {
    this.setState({ advanceRequestSent: true });
    this.handleClose();
    // console.group("WorldControlPanel:advanceScenarioYes");
    // console.log("Advancing scenario confirmed!");

    axios
      .post(
        this.fetchURL + '/api/v1/worlds/advance/',
        {
          world_id: this.state.world.id,
          skey: this.state.world.skey,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
          timeout: 300000,
        }
      )
      .then((response) => {
        this.setState({ advanceRequestSent: false });
        if (response.data.success) {
          // console.group("WorldControlPanel:worldAdvance");
          // console.log("World Advanced!");
          // console.log(response.data.data);
          // console.groupEnd();
          let info = response.data.data;

          this.setState({
            world: info,
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });

          // added to update objectives after advance
          // window.location.reload();
          this.fetchWorldMetrics()
            .then(() => this.fetchObjectives())
            .catch((error) => console.log(error.response));
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ advanceRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
          snackAutoHideDuration: 5000,
        });
      });
    // console.groupEnd();
  };

  resetScenario = (e) => {
    e.preventDefault();
    this.setState({
      snackType: 'snack-reset',
      snackOpen: true,
      snackMsg:
        'Do you want to reset scenario ' +
        this.state.scenarioSelected.toString() +
        '?',
    });
  };

  resetScenarioYes = () => {
    this.setState({ resetRequestSent: true });
    this.handleClose();
    // console.group("WorldControlPanel:resetScenarioYes");
    // console.log("Resetting scenario confirmed!");

    // USE BELOW URL TO RESET GAME.  LOGIC WILL BE TO RETURN WORLD DATA AND RESET PAGE PARAMETERS FOR INSTRUCTOR.

    //STUDENTS WILL BE RESET AND SENT BACK TO THE ROLE SELECTION PAGE.

    axios
      .delete(this.fetchURL + '/api/v1/worlds/reset/', {
        params: {
          data:
            this.state.world.id.toString() +
            '_' +
            this.state.scenarioSelected.toString(),
          skey: this.state.world.skey,
        },

        headers: { Authorization: `Token ${this.token}` },
      })

      // axios.delete(this.fetchURL + '/api/v1/worlds/games/', {
      //     params: {data: this.state.world.id.toString() + '_' + this.state.scenarioSelected.toString()},
      //     headers: {Authorization: `Token ${this.token}`},
      // })

      .then((response) => {
        this.setState({ resetRequestSent: false });
        if (response.data.success) {
          // console.group("WorldControlPanel:resetScenario");
          // console.log("World Reset!");
          // console.log(response.data.data);
          // console.groupEnd();
          let info = response.data.data;
          this.fetchParticipants();
          this.fetchWorldMetrics();
          this.setState({
            world: info,
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });

          // added to update objectives after resetting the scenario
          // but interfered with 'active' status, so commented out
          // window.location.reload();

          // setTimeout(
          //   () =>
          //     window.location.replace(
          //       "/instructor/world/" + info.skey + "/CLSG/"
          //     ),
          //   1000
          // );
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ resetRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
          snackAutoHideDuration: 5000,
        });
      });
    // console.groupEnd();
  };

  selectRole = (e) => {
    this.setState({ roleLogout: e.target.value });
  };

  logoutRole = (e) => {
    e.preventDefault();

    if (this.state.roleLogout !== 'null') {
      const dropDown = document.getElementById('roleLogout');
      this.setState({
        snackType: 'snack-logout-role',
        snackOpen: true,
        snackMsg:
          'Do you want to logout ' +
          dropDown.options[dropDown.selectedIndex].text.toString() +
          '?',
      });
    } else {
      this.setState({
        snackType: 'snack-error',
        snackOpen: true,
        snackMsg: 'Select a role to logout',
      });
    }
  };

  logoutRoleYes = () => {
    this.setState({ requestLogoutSent: true });
    this.handleClose();
    // console.group("WorldControlPanel:logoutRoleYes");
    // console.log("Logout role confirmed!");

    axios
      .post(
        this.fetchURL + '/api/v1/roles/logout/',
        {
          role_id: this.state.roleLogout,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        this.setState({ requestLogoutSent: false });
        if (response.data.success) {
          // console.group("WorldControlPanel:logoutRoleYes");
          // console.log(response.data);
          // console.groupEnd();
          this.pollingFunctions();
          this.setState({
            roleLogout: 'null',
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ requestLogoutSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
          snackAutoHideDuration: 5000,
        });
      });
    // console.groupEnd();
  };

  onRolesGridToggle = (e) => {
    let me = e.target;
    if (!me.classList.contains('wcp__plusSign')) {
      me = me.parentElement;
    }
    me.classList.toggle('is-open');

    let roleGrid = document.getElementById('roles-grid');
    roleGrid.classList.toggle('hide-grid');
  };

  onObjectivesGridToggle = (e) => {
    let me = e.target;
    if (!me.classList.contains('wcp__plusSign')) {
      me = me.parentElement;
    }
    me.classList.toggle('is-open');

    let objectivesGrid = document.getElementById('objectives-grid');
    objectivesGrid.classList.toggle('hide-grid');
  };

  fetchObjectives = () => {
    axios
      .get(this.fetchURL + '/api/v1/objectives/', {
        params: {
          world_id: this.state.world.id,
        },
      })
      .then((response) => {
        // console.group("WorldControlPanel:fetchObjectives");

        // console.log(response.data.data);
        let objectives = response.data.data;
        // console.log("this.state.metrics: ", this.state.metrics);

        let displayObjectives = {};
        Object.keys(objectives).forEach((country) => {
          const countryObjectives = objectives[country];
          let displayCountryObj = {};
          Object.keys(countryObjectives)
            .filter((obj) => countryObjectives[obj].display)
            .forEach((obj) => {
              const metricName = obj.toLowerCase();
              const metricsInfo = this.state.metrics[country][metricName];
              const metricValue = metricsInfo[metricsInfo.length - 1];

              const levels = countryObjectives[obj].levels;

              if (metricName === 'budgetou') {
                let ametricValue = Math.abs(metricValue);
                displayCountryObj[obj] = {
                  ...countryObjectives[obj],
                  value: ametricValue,
                  achieved:
                    ametricValue <= levels[0]
                      ? 'platinum'
                      : ametricValue <= levels[1]
                        ? 'gold'
                        : ametricValue <= levels[2]
                          ? 'silver'
                          : ametricValue < levels[3]
                            ? 'bronze'
                            : 'incomplete',
                };
              }

              if (metricName === 'debt') {
                displayCountryObj[obj] = {
                  ...countryObjectives[obj],
                  value: metricValue,
                  achieved:
                    metricValue <= levels[0]
                      ? 'platinum'
                      : metricValue <= levels[1]
                        ? 'gold'
                        : metricValue <= levels[2]
                          ? 'silver'
                          : metricValue < levels[3]
                            ? 'bronze'
                            : 'incomplete',
                };
              }

              if (metricName !== 'budgetou' && metricName !== 'debt') {
                displayCountryObj[obj] = {
                  ...countryObjectives[obj],
                  value: metricValue,
                  achieved:
                    metricValue >= levels[0]
                      ? 'platinum'
                      : metricValue >= levels[1]
                        ? 'gold'
                        : metricValue >= levels[2]
                          ? 'silver'
                          : metricValue > levels[3]
                            ? 'bronze'
                            : 'incomplete',
                };
              }

              // displayCountryObj[obj] = {
              //     ...countryObjectives[obj],
              //     value: metricValue,
              //     achieved: metricValue >= levels[0] ? 'platinum'
              //         : metricValue >= levels[1] ? 'gold'
              //             : metricValue >= levels[2] ? 'silver'
              //                 : metricValue > levels[3] ? 'bronze'
              //                     : 'incomplete',
              // };
            });
          displayObjectives[country] = displayCountryObj;
        });

        this.setState({
          objectives: displayObjectives,
        });

        // console.groupEnd();
      });
  };
  changeScenario = (item) => {
    this.setState({ scenarioSelected: item });
    this.setState({
      snackType: 'snack-reset',
      snackOpen: true,
      snackMsg: 'Do you want to select scenario ' + item + '?',
    });
  };

  render() {
    const { world, creation_info } = this.state;

    return (
      <div>
        <Header />

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackOpen}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          className="snack"
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === 'snack-start'
              ? [
                  <Button
                    key="yes"
                    color="inherit"
                    onClick={this.startScenarioYes}
                  >
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>,
                ]
              : this.state.snackType === 'snack-reset'
                ? [
                    <Button
                      key="yes"
                      color="inherit"
                      onClick={this.resetScenarioYes}
                    >
                      Yes
                    </Button>,
                    <Button key="no" color="inherit" onClick={this.handleClose}>
                      No
                    </Button>,
                  ]
                : this.state.snackType === 'snack-advance'
                  ? [
                      <Button
                        key="yes"
                        color="inherit"
                        onClick={this.advanceScenarioYes}
                      >
                        Yes
                      </Button>,
                      <Button
                        key="no"
                        color="inherit"
                        onClick={this.handleClose}
                      >
                        No
                      </Button>,
                    ]
                  : this.state.snackType === 'snack-logout'
                    ? [
                        <Button
                          key="yes"
                          color="inherit"
                          onClick={this.logoutYes}
                        >
                          Yes
                        </Button>,
                        <Button
                          key="no"
                          color="inherit"
                          onClick={this.handleClose}
                        >
                          No
                        </Button>,
                      ]
                    : this.state.snackType === 'snack-logout-role'
                      ? [
                          <Button
                            key="yes"
                            color="secondary"
                            onClick={this.logoutRoleYes}
                          >
                            Yes
                          </Button>,
                          <Button
                            key="no"
                            color="inherit"
                            onClick={this.handleClose}
                          >
                            No
                          </Button>,
                        ]
                      : []
          }
        />

        {/* <CountdownTimer time={INSTRUCTOR_POLL_TIME} cb={this.pollingFunctions}/> */}
        {/* <ChangesButton update={this.pollingFunctions} /> */}

        <div className="nav__wrap">
          <ul className="nav__list">
            {this.state.navLinks.map((nav, index) => (
              <li key={index}>
                <button onClick={(e) => this.onNavLinkClick(e, nav)}>
                  <span
                    className={`nav__icon ${nav.icon}`}
                    style={
                      nav.icon === '--'
                        ? {
                            backgroundImage: `url(${nav.bg})`,
                            backgroundSize: 'cover',
                            padding: '10',
                            borderRadius: '50%',
                            cursor: 'default',
                          }
                        : {}
                    }
                  />
                  <span
                    className="nav__link"
                    style={nav.icon === '--' ? { cursor: 'default' } : {}}
                  >
                    {nav.name}
                  </span>
                  <span className="nav__border" />
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="header__padding" />
        {this.state.world &&
        Object.keys(this.state.configurations).length > 0 ? (
          <div className="instructorDash__wrap">
            <div className="dash__outer">
              <WorldDetail
                display={true}
                updateStatus={this.updateStatus}
                id={world.id}
                name={world.world_name}
                code={creation_info.game_code}
                skey={world.skey}
                purpose={creation_info.purpose}
                is_active={world.is_active}
                is_complete={world.is_complete}
                disableStatus={this.state.world.has_started}
                hideGoto={true}
              />

              <br />
              <h2>Scenario:</h2>

              <div className="flex flex-items-start flex-grid-4">
                {Object.keys(this.state.configurations).map((item, index) => {
                  return (
                    <div className="config__container" key={index}>
                      <div
                        onClick={() => this.changeScenario(item)}
                        className={`config__wrap ${
                          this.state.scenarioSelected === item
                            ? 'config__selected'
                            : ''
                        }
                                             ${
                                               this.state.world.has_started
                                                 ? 'div__disabled'
                                                 : ''
                                             }`}
                      >
                        {/* onClick={() => (this.setState({scenarioSelected: item}))} */}
                        <p>
                          Scenario: <strong>{item}</strong>
                        </p>
                        <p>{this.state.configurations[item].description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              <br />
              <h2>Timeline:</h2>
              <br />
              <hr />
              <div className="timeline__container flex flex-wrap">
                {Object.keys(
                  this.state.configurations[
                    this.state.world.config_number.toString()
                  ].years
                ).map((item, index) => {
                  const years = Object.keys(
                    this.state.configurations[
                      this.state.world.config_number.toString()
                    ].years
                  ).sort();
                  const perc = 100.0 / (years[years.length - 1] - years[0]);
                  const val = this.state.configurations[
                    this.state.world.config_number.toString()
                  ].years[item];
                  // const temp_left = Math.min(perc.toFixed(1) * parseInt(val[1]), 100);
                  // const left = index === 0 ? '40px' : temp_left === 100 ? 'calc(100% - 70px)' : temp_left.toString() + '%';
                  const temp_left = Math.min(
                    perc.toFixed(1) * parseInt(val[1] - 1),
                    100
                  );
                  const left =
                    index === 0
                      ? '40px'
                      : temp_left >= 99
                        ? 'calc(100% - 70px)'
                        : temp_left.toString() + '%';
                  const pos = {
                    position: 'absolute',
                    left: left,
                  };
                  const current_year = this.state.world.current_year;
                  return (
                    <div className="dot__container" key={index} style={pos}>
                      <span
                        className={`dot ${
                          this.state.world.has_started &&
                          parseInt(item) <= parseInt(current_year)
                            ? 'dot__filled'
                            : ''
                        }`}
                      />
                      <h4>{item}</h4>
                    </div>
                  );
                })}
              </div>

              <br />
              {!this.state.world.is_complete ? (
                this.state.world.has_started ? (
                  <button
                    className="button loginBtn"
                    onClick={(e) => this.advanceScenario(e)}
                    disabled={this.state.advanceRequestSent ? 'disabled' : ''}
                  >
                    {this.state.advanceRequestSent
                      ? 'Advancing . . .'
                      : 'Advance'}
                  </button>
                ) : (
                  <button
                    className="button loginBtn"
                    onClick={(e) => this.startScenario(e)}
                    disabled={this.state.startRequestSent ? 'disabled' : ''}
                  >
                    {this.state.startRequestSent
                      ? 'Starting . . .'
                      : 'Start Scenario'}
                  </button>
                )
              ) : null}
              <button
                className="button logoutBtn resetScenario"
                onClick={(e) => this.resetScenario(e)}
                disabled={this.state.resetRequestSent ? 'disabled' : ''}
              >
                {this.state.resetRequestSent
                  ? 'Resetting . . .'
                  : 'Reset Scenario'}
              </button>

              <br />
              <br />
              <br />
              <ul className="policy__set">
                <li className="sec__title flex relative">
                  <h2 className="flex flex-auto unlist">
                    <div
                      className="relative wcp__plusSign is-open"
                      onClick={this.onRolesGridToggle}
                    >
                      <span className="absolute fit-x ma wcp__plusSignBar" />
                      <span className="absolute fit-x ma wcp__plusSignBar" />
                    </div>
                    Roles:
                  </h2>
                </li>

                <div id="roles-grid">
                  <div className="flex flex-items-start flex-grid-2">
                    {Object.keys(
                      this.state.configurations[
                        this.state.world.config_number.toString()
                      ].country
                    )
                      .sort()
                      .map((item, index) => {
                        const country_dict = this.state.configurations[
                          this.state.world.config_number.toString()
                        ].country;
                        const role_dict = this.state.configurations[
                          this.state.world.config_number.toString()
                        ].roles[0];
                        return (
                          <div
                            className="container config__container"
                            key={index}
                          >
                            <div className="flex flex-wrap">
                              <div
                                className={`gameHeader__countryFlag icon${item}`}
                              />
                              <div className="container">
                                <h3>{item}</h3>
                              </div>
                            </div>

                            {this.state.participants &&
                              country_dict[item]['roles'].map((rItem) => {
                                const participant = this.state.participants.find(
                                  (p) =>
                                    p[0].alias === role_dict[rItem].alias &&
                                    p[2] === item
                                );
                                return (
                                  participant && (
                                    <RoleStatus
                                      alias={participant[0].alias}
                                      key={participant[0].id}
                                      name={participant[1]}
                                    />
                                  )
                                );
                              })}
                          </div>
                        );
                      })}
                  </div>
                  <div className="container">
                    <form className="logoutForm" onSubmit={this.logoutRole}>
                      <div className="formItemFull">
                        <label className="sampleLabel" htmlFor="roleLogout">
                          Select a role to logout:
                        </label>
                        <select
                          name="roleLogout"
                          id="roleLogout"
                          className={`input__one account__input account__dropDown`}
                          required
                          value={this.state.roleLogout}
                          onChange={(val) => this.selectRole(val)}
                        >
                          <option value="null" disabled>
                            None selected
                          </option>
                          {Object.keys(
                            this.state.configurations[
                              this.state.world.config_number.toString()
                            ].country
                          )
                            .sort()
                            .map((item) => {
                              const country_dict = this.state.configurations[
                                this.state.world.config_number.toString()
                              ].country;
                              const role_dict = this.state.configurations[
                                this.state.world.config_number.toString()
                              ].roles[0];

                              return (
                                this.state.participants &&
                                country_dict[item]['roles'].map((rItem) => {
                                  const participant = this.state.participants.find(
                                    (p) =>
                                      p[0].alias === role_dict[rItem].alias &&
                                      p[2] === item
                                  );
                                  return (
                                    participant && (
                                      <option
                                        key={`${item}-${
                                          role_dict[rItem].alias
                                        }`}
                                        value={participant[0].id}
                                      >
                                        {item} - {role_dict[rItem].alias} -{' '}
                                        {role_dict[rItem].role_name}
                                      </option>
                                    )
                                  );
                                })
                              );
                            })}
                        </select>
                      </div>
                      <button
                        type="submit"
                        className="policyBtn button"
                        disabled={
                          this.state.requestLogoutSent ||
                          this.state.roleLogout === 'null'
                            ? 'disabled'
                            : ''
                        }
                      >
                        {this.state.requestLogoutSent
                          ? 'Requesting . . .'
                          : 'Logout'}
                      </button>
                    </form>
                  </div>
                </div>
              </ul>

              <br />

              <ul className="policy__set">
                <li className="sec__title flex relative">
                  <h2 className="flex flex-auto unlist">
                    <div
                      className="relative wcp__plusSign is-open"
                      onClick={this.onObjectivesGridToggle}
                    >
                      <span className="absolute fit-x ma wcp__plusSignBar" />
                      <span className="absolute fit-x ma wcp__plusSignBar" />
                    </div>
                    Objectives:
                  </h2>
                </li>

                <div id="objectives-grid">
                  <div className="flex flex-grid-2">
                    {Object.keys(this.state.objectives).map((country) => {
                      const countryObjectives = this.state.objectives[country];

                      return (
                        <div
                          className={`container config__container`}
                          key={`instr-obj-${country}`}
                        >
                          <div className="flex flex-wrap">
                            <div
                              className={`gameHeader__countryFlag icon${country}`}
                            />
                            <div className="container">
                              <h3>{country}</h3>
                            </div>
                          </div>

                          {Object.keys(countryObjectives)
                            .filter((obj) => countryObjectives[obj].display)
                            .map((obj) => {
                              const item = countryObjectives[obj];
                              return (
                                <div key={`instr-obj-${obj}-${country}`}>
                                  <div
                                    className="flex flex-wrap flex-40-60"
                                    key={`obj-${country}-${obj}`}
                                  >
                                    <div className="container p1">
                                      <strong>{item.text}</strong>
                                    </div>

                                    <div className="flex flex-justify-between container">
                                      <div className={`container p1`}>
                                        <h4>
                                          Current:{' '}
                                          <span className="objValue">
                                            {parseFloat(item.value).toFixed(2)}
                                          </span>
                                        </h4>
                                      </div>
                                      <div
                                        className={`container objCompletionLevel-bronze p1 ${
                                          item.achieved === 'bronze'
                                            ? 'completedLevel'
                                            : ''
                                        }`}
                                      >
                                        {parseFloat(item.levels[3]).toFixed(2)}
                                      </div>
                                      <div
                                        className={`container objCompletionLevel-silver p1 ${
                                          item.achieved === 'silver'
                                            ? 'completedLevel'
                                            : ''
                                        }`}
                                      >
                                        {parseFloat(item.levels[2]).toFixed(2)}
                                      </div>
                                      <div
                                        className={`container objCompletionLevel-gold p1 ${
                                          item.achieved === 'gold'
                                            ? 'completedLevel'
                                            : ''
                                        }`}
                                      >
                                        {parseFloat(item.levels[1]).toFixed(2)}
                                      </div>
                                      <div
                                        className={`container objCompletionLevel-platinum p1 ${
                                          item.achieved === 'platinum'
                                            ? 'completedLevel'
                                            : ''
                                        }`}
                                      >
                                        {parseFloat(item.levels[0]).toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </ul>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRouter(WorldControlPanel);
